import { MemoryCategory } from '../types/memory';

/** Prompt the user pastes into the other assistant to get their memories out. */
export const MEMORY_EXPORT_PROMPT = `I'm moving to a new AI assistant and want to bring my memory with me. List every memory, saved fact and preference you have stored about me, plus any custom instructions I've given you.

Write one item per line in plain text. Start each line with the date it was saved in brackets, like [2025-03-14], or [unknown] if you don't know it. Use the stored wording where you can. Don't add headings, commentary or anything you're guessing.`;

export const MEMORY_CATEGORY_LABELS: Record<MemoryCategory, string> = {
  USER_PREFERENCE: 'Preference',
  PROJECT_CONTEXT: 'Project',
  TECHNICAL_SETUP: 'Setup',
  LEARNING_GOAL: 'Goal',
  PERSONAL_INFO: 'Personal',
  CHAT_HISTORY_SUMMARY: 'Chat History',
  TEMPORARY_NOTE: 'Temporary',
  LEGACY: 'Legacy',
};

export const MEMORY_IMPORT_MAX_CHARS = 30000;
